<template>
  <form @submit.prevent="handleSubmit()" class="regular-form">

    <!-- Name -->
    <city-name-field
      v-model="$attrs.city.name"
      :error="$attrs.errors.city.name"
    />

    <div class="form-group text-center">
      <input class="btn btn-primary btn-lg" type="submit" :value="submitLabel">
    </div>
  </form>
</template>

<script>
import cityNameField from '@/components/forms/city/fields/CityName'

export default {
  name: 'city-blank-form',
  inheritAttrs: false,
  props: {
    submitLabel: {
      type: String,
      default: 'Submit'
    },
    formType: {
      type: String,
      required: true
    }
  },
  components: {
    cityNameField
  },
  methods: {
    handleSubmit () {
      this.$emit('submit')
    }
  }
}
</script>



// WEBPACK FOOTER //
// CityBlankForm.vue?2222bd47